import api from './client'

/** Every theme name, alphabetically — suggestions for the tag input. */
export function fetchThemes() {
  return api.get<{ data: string[] }>('/themes')
}
